import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import {httpOptions} from '@portal-workspace/grow-ui-library';
import { environment } from '../../environments/environment';
import { CronJob,CronJobPaginablePayloadApiResponse,GetCronJobsFn, CronJobInstanceWithCronJob, GetCronJobInstancesFn, CronJobInstancePaginablePayloadApiResponse, RunCronJobFn, GetCronJobsGroupedFn, CronJobGroupedPayloadApiResponse} from '@portal-workspace/grow-shared-library';

const URL_GET_CRON_JOBS = (limit: number, offset: number, filter: string | null, category: string | null) => `${environment.api2Host}/api2/cron/get-cron-jobs?limit=${limit}&offset=${offset}&filter=${filter}&category=${category}`;
const URL_GET_CRON_JOBS_GROUPED = (filter: string | null) => `${environment.api2Host}/api2/cron/get-cron-jobs?groupByCategory=true&filter=${filter}`;
const URL_GET_CRON_JOB_INSTANCES = (limit: number, offset: number, filter: string | null, cronJobId: number | null, status: string | null) => `${environment.api2Host}/api2/cron/get-cron-job-instances?limit=${limit}&offset=${offset}&filter=${filter}&cronJobId=${cronJobId}&status=${status}`;
const URL_RUN_CRON_JOB = (route: string) => `${environment.api2Host}/api2/${route}`;
@Injectable({
  providedIn: 'root'
})


export class CronJobService {

  constructor(
    private httpClient: HttpClient,
  ) { }
 
  getCronJobInstances = (limit: number, offset: number, filter: string | null, cronJobId: number | null, status: string | null): Observable<CronJobInstancePaginablePayloadApiResponse<CronJobInstanceWithCronJob> | null> => {
    return this.httpClient.get<CronJobInstancePaginablePayloadApiResponse<CronJobInstanceWithCronJob>>(URL_GET_CRON_JOB_INSTANCES(limit, offset, filter, cronJobId, status),httpOptions());
  }

  getCronJobInstancesFn: GetCronJobInstancesFn = (limit: number, offset: number, filter: string | null, cronJobId: number | null, status: string | null) => {
    return this.getCronJobInstances(limit, offset, filter, cronJobId, status).pipe(
      map(response => response || null)
    );
  }

  getCronJobs = (limit: number, offset: number, filter: string | null, category: string | null): Observable<CronJobPaginablePayloadApiResponse<CronJob> | null> => {
    return this.httpClient.get<CronJobPaginablePayloadApiResponse<CronJob> | null>(URL_GET_CRON_JOBS(limit, offset, filter, category),httpOptions());
  }

  getCronJobsFn: GetCronJobsFn = (limit: number, offset: number, filter: string | null, category: string | null) => {
    return this.getCronJobs(limit, offset, filter, category).pipe(
      map(response => response || null)
    );
  }

  getCronJobsGrouped = (filter: string | null): Observable<CronJobGroupedPayloadApiResponse | null> => {
    return this.httpClient.get<CronJobGroupedPayloadApiResponse | null>(URL_GET_CRON_JOBS_GROUPED(filter), httpOptions());
  }

  getCronJobsGroupedFn: GetCronJobsGroupedFn = (filter: string | null) => {
    return this.getCronJobsGrouped(filter).pipe(
      map(response => response || null)
    );
  }
 
  runCronJob = (route: string): Observable<any> => {
    return this.httpClient.get(URL_RUN_CRON_JOB(route),httpOptions());
  }

  runCronJobFn: RunCronJobFn = (route: string) => {
    return this.runCronJob(route).pipe(
      map(response => response || null)
    );
  }

 
}
